import { render, staticRenderFns } from "./ssztMap.vue?vue&type=template&id=2645759c&scoped=true&"
import script from "./ssztMap.vue?vue&type=script&lang=js&"
export * from "./ssztMap.vue?vue&type=script&lang=js&"
import style0 from "./ssztMap.vue?vue&type=style&index=0&id=2645759c&lang=stylus&scoped=true&"
import style1 from "./ssztMap.vue?vue&type=style&index=1&id=2645759c&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2645759c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("K:\\website\\tmp\\2021.7-12\\mmlzcyy_project\\screen\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2645759c')) {
      api.createRecord('2645759c', component.options)
    } else {
      api.reload('2645759c', component.options)
    }
    module.hot.accept("./ssztMap.vue?vue&type=template&id=2645759c&scoped=true&", function () {
      api.rerender('2645759c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/map/newMap/ssztMap.vue"
export default component.exports